/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React from 'react';
import Props, {DispatchProps, StateProps} from './Props';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {accountEmailChangeSceneActivated, accountEmailChangeSceneDeactivated} from './actions';
import {DisplayType} from './displayType';
import CenteredPanel from '../../components/CenteredPanel';
import CenteredSpinner from '../../components/CenteredSpinner';
import {Alert} from 'react-bootstrap';
import {RootState} from '../../reducers';

class AccountEmailChange extends React.Component<Props> {

	componentDidMount() {
		const props: Readonly<Props> = this.props;

		props.onActivate();
	}

	componentWillUnmount() {
		const props: Readonly<Props> = this.props;

		props.onDeactivate();
	}

	render() {
		const props: Readonly<Props> = this.props;

		let display: JSX.Element | null;
		switch (props.displayType) {
			case DisplayType.DISPLAY_TYPE_LOADING:
				return <CenteredSpinner/>;
			case DisplayType.DISPLAY_TYPE_VERIFIED:
				display = <Alert variant="success">{'Je e-mailadres is gewijzigd, je kunt dit venster sluiten.'}</Alert>;
				break;
			case DisplayType.DISPLAY_TYPE_OUTDATED:
				display = <Alert variant="warning">{'Deze link is niet (meer) geldig, je kunt dit venster sluiten.'}</Alert>;
				break;
			case DisplayType.DISPLAY_TYPE_NONE:
			default:
				display = null;
		}

		return (
			<CenteredPanel title="E-mailadres wijzigen">{display}</CenteredPanel>
		);
	}
}

const mapStateToProps = (state: RootState): StateProps => ({
	displayType: state.accountEmailChange.displayType
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onActivate: () => dispatch(accountEmailChangeSceneActivated()),
	onDeactivate: () => dispatch(accountEmailChangeSceneDeactivated())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountEmailChange);
